export type CardString = 'AS' | '2S' | '3S' | '4S' | '5S' | '6S' | '7S' | '8S' | '9S' | '10S' | 'JS' | 'QS' | 'KS' | 'AH' | '2H' | '3H' | '4H' | '5H' | '6H' | '7H' | '8H' | '9H' | '10H' | 'JH' | 'QH' | 'KH' | 'AC' | '2C' | '3C' | '4C' | '5C' | '6C' | '7C' | '8C' | '9C' | '10C' | 'JC' | 'QC' | 'KC' | 'AD' | '2D' | '3D' | '4D' | '5D' | '6D' | '7D' | '8D' | '9D' | '10D' | 'JD' | 'QD' | 'KD';

export enum Suit {
	Spades = 'S',
	Hearts = 'H',
	Clubs = 'C',
	Diamonds = 'D',
}

export enum Rank {
	Ace = 'A',
	King = 'K',
	Queen = 'Q',
	Jack = 'J',
	Ten = '10',
	Nine = '9',
	Eight = '8',
	Seven = '7',
	Six = '6',
	Five = '5',
	Four = '4',
	Three = '3',
	Two = '2',
}

export interface ActionData {
}
